import { useEffect, useState } from "react";

const navLinks = [
  { label: "现场热榜", href: "#topics" },
  { label: "直击现场", href: "#scene" },
  { label: "围观进行时", href: "#timeline" },
  { label: "围观守则", href: "#faq" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={
        "fixed inset-x-0 top-0 z-50 transition-colors duration-300 " +
        (solid
          ? "border-b border-background-200/70 bg-background-50/90 backdrop-blur-md"
          : "border-b border-transparent bg-transparent")
      }
    >
      <div className="shell flex h-16 items-center justify-between md:h-[72px]">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-eye-line text-lg"></i>
          </span>
          <span className="flex items-baseline gap-2">
            <h1
              className={
                "font-serif text-xl font-bold tracking-tight md:text-2xl " +
                (solid ? "text-foreground-950" : "text-background-50")
              }
            >
              91群众
            </h1>
            <span
              className={
                "hidden text-xs md:inline " +
                (solid ? "text-foreground-500" : "text-background-50/70")
              }
            >
              围观现场直击
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={
                "text-sm whitespace-nowrap transition-colors hover:text-primary-500 " +
                (solid ? "text-foreground-700" : "text-background-50/90")
              }
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#scene"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200/60 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-500"
            aria-label="搜索现场"
          >
            <i className="ri-search-line"></i>
          </a>
          <a
            href="#faq"
            className="inline-flex h-9 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-camera-lens-line"></i>
            发布现场
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={
            "flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border md:hidden " +
            (solid
              ? "border-background-200/70 text-foreground-900"
              : "border-background-50/30 text-background-50")
          }
          aria-label="打开菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 backdrop-blur-md md:hidden">
          <div className="shell flex flex-col gap-1 py-3">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-camera-lens-line"></i>
              发布现场
            </a>
          </div>
        </div>
      )}
    </header>
  );
}